'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$85() {
  this.boo = null;
  this.bop = false;
}
export { $c_Lpresto_PrestoRouter$$anon$85 as $c_Lpresto_PrestoRouter$$anon$85 };
$p = $c_Lpresto_PrestoRouter$$anon$85.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$85;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$85() {
}
export { $h_Lpresto_PrestoRouter$$anon$85 as $h_Lpresto_PrestoRouter$$anon$85 };
$h_Lpresto_PrestoRouter$$anon$85.prototype = $p;
$p.bW = (function() {
  if ((!this.bop)) {
    this.boo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bop = true;
  }
  return this.boo;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$85 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$85, "presto.PrestoRouter$$anon$85", ({
  OT: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$85 as $d_Lpresto_PrestoRouter$$anon$85 };
//# sourceMappingURL=presto.-Presto-Router$$anon$85.js.map
